<div class="component-main-container">
  <!-- Cabeçalho -->
  <div class="header">
    <app-page-header parentTitle="{{'installations.parentTitle' | translate}}"
      pageTitle="{{'installations.pageTitle' | translate}}">
    </app-page-header>
  </div>

  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!-- Tipos de registro -->
        <app-register-form></app-register-form>

        <!-- Modal de filtros -->
        <div class="form-fields-box" [formGroup]="filterForm" [ngClass]="!filterInstallation ? 'closed' : ''">
          <h2 (click)="filterBoxOpen()"> {{"installations.filter-form" | translate}} </h2>
          <hr [ngClass]="!filterInstallation ? 'hr-open' : ''" />

          <!-- Campo de busca por referencia da instalação -->
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
            <mat-tab label="{{'installations.mat-tab-filter-reference' | translate}}">
              <br>
              <div class="form-step">
                <div class="circle-number"> 1 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{"installations.filter-form-reference" | translate}} </mat-label>
                  <input matInput formControlName="referenceFilter" #referenceFilter>
                </mat-form-field>
              </div>
              <!-- Botões do filtro. -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-50" (click)="filterInstallations(null)">
                  {{"installations.button-filter" | translate}}
                </button>
                }
                @if (!filterLoading) {
                <button (click)="clearFilterForm()" class="btn btn-secondary m-1 w-50">
                  {{"installations.button-clean-filter" | translate}} </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>

            <!-- Campo para realizar a busca de equipamentos por numero de série -->
            <mat-tab label="{{'installations.mat-tab-filter-equipment-type' | translate}}">
              <br>
              <div class="form-step">
                <div class="circle-number">2</div>
                <mat-form-field appearance="outline">
                  <mat-label> {{"installations.filter-form-equipment-type" | translate}}</mat-label>
                  <input matInput formControlName="equipmentsTypeFilter" #serialNumberFilter>
                  <mat-icon class="component-search-icon" (click)="searchEquipmentsFilter(serialNumberFilter.value)"
                    svgIcon="bx-search"></mat-icon>
                </mat-form-field>
              </div>

              <!-- Loading -->
              @if (equipmentsLoadingFilter) {
              <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
              }

              <!-- Lista os equipamentos filtrados -->
              @if (equipmentListFilter.length > 0) {
              <div class="form-step">
                <div class="circle-number-ready"> 2.1 </div>
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{"installations.filter-form-select-equipment" | translate}}
                  </mat-label>
                  <mat-select formControlName="selectedEquipmentFilter" #value>
                    @for (equipment of equipmentListFilter; track equipment) {
                    <mat-option apperance="outline" [value]="equipment.id">
                      {{equipment.serialNumber}} ({{equipment.reference}}
                      {{equipment.major}}.{{equipment.minor}}.{{equipment.revision}} )
                    </mat-option>
                    }
                    @if (equipmentListFilter.length < 0) { <mat-option>
                      {{"installations.filter-form-no-equipments" | translate}}
                      </mat-option>
                      }
                  </mat-select>
                </mat-form-field>
              </div>
              }
              <!-- Botões do filtro. -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-50" (click)="filterInstallations(null)">
                  {{"installations.button-filter" | translate}}
                </button>
                }
                @if (!filterLoading) {
                <button (click)="clearFilterForm()" class="btn btn-secondary m-1 w-50">
                  {{"installations.button-clean-filter" | translate}}
                </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>

            <!-- Campo para realizar a busca por locais de instalações -->
            <mat-tab label="{{'installations.mat-tab-filter-installation-site' | translate}}">
              <br>
              <div class="form-step">
                <div class="circle-number"> 3 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{"installations.filter-form-installation-location" | translate}} </mat-label>
                  <input matInput [placeholder]="filterPlaceholder" #filter>
                  <mat-icon class="component-search-icon" svgIcon="bx-search"></mat-icon>
                </mat-form-field>
              </div>

              <div class="row form">
                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> CEP </mat-label>
                    <input matInput mask="00000-000" [(ngModel)]="filterPostalCode" disabled=""
                      [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> {{"installations.filter-form-public-place" | translate}} </mat-label>
                    <input matInput [(ngModel)]="filterPublicPlace" disabled="" #street
                      [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> {{"installations.filter-form-district" | translate}} </mat-label>
                    <input matInput [(ngModel)]="filterDistrict" disabled="" #district
                      [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> {{"installations.filter-form-city" | translate}} </mat-label>
                    <input matInput [(ngModel)]="filterCity" disabled="" #city [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> {{"installations.filter-form-state" | translate}} </mat-label>
                    <input matInput [(ngModel)]="filterState" disabled="" #state [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>

                <div class="form-step">
                  <mat-form-field appearance="outline">
                    <mat-label> {{"installations.filter-form-country" | translate}} </mat-label>
                    <input matInput [(ngModel)]="filterCountry" disabled="" #country
                      [ngModelOptions]="{standalone: true}">
                  </mat-form-field>
                </div>
              </div>

              <!-- Botões do filtro . -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-50" (click)="filterInstallations(
                  null)">
                  {{"installations.button-filter" | translate}}
                </button>
                }

                @if (!filterLoading) {
                <button (click)="clearFilterForm()" class="btn btn-secondary m-1 w-50">
                  {{"installations.button-clean-filter" | translate}}
                </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Modal que registra a instalação -->
        <div class="form-fields-box" [formGroup]="createForm" [ngClass]="!registerInstallation ? 'closed' : ''">
          <h2 (click)="registerBoxOpen()"> {{"installations.register-form" | translate}} </h2>
          <hr [ngClass]="!registerInstallation ? 'hr-open' : ''" />

          <section>
            @if (!hasMagneticKey) {
            <mat-checkbox (change)="isVirtualInstallation($event.checked)">
              {{"installations.register-form-virtual-installation" | translate}}
            </mat-checkbox>
            }
            @if (!virtualInstallationCheck) {
            <mat-checkbox (change)="ifHasMagneticKey($event.checked)" formControlName="hasMagneticKey">
              {{"installations.register-form-magnetic-key" | translate}}
            </mat-checkbox>
            }
          </section>
          <br>

          <div class="form-step">
            <div class="circle-number"> 1 </div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input pInputText fluid formControlName="referenceCreate" id="reference"
                  [pKeyFilter]="blockSpecialCharacters"
                  [class.p-invalid]="createForm.get('referenceCreate')?.invalid && createForm.get('referenceCreate')?.touched" />
                <label for="reference">{{'installations.register-form-reference' | translate}}</label>
              </p-floatlabel>
              @if (
              createForm.get('referenceCreate')?.hasError('pattern') &&
              createForm.get('referenceCreate')?.touched
              ) {
              <small class="p-error" style="color: red;">
                {{'installations.special-character-error' | translate}}
              </small>
              }
            </div>
          </div>

          <!-- Campo para realizar a busca de locais de instalações -->
          <div class="form-step">
            <div class="circle-number"> 2 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-installation-location" | translate}} </mat-label>
              <input matInput formControlName="installationSite" #referenceSiteCreate>
              <mat-icon class="component-search-icon" (click)="searchInstallationSite(referenceSiteCreate.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>

          <!-- Campo que lista os locais de instalações  -->
          @if (installationSiteList.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready"> 2.1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-select-installation-location" | translate}} </mat-label>
              <mat-select formControlName="selectedInstallationSite" required="true">
                @for (site of installationSiteList; track site) {
                <mat-option [value]="site.id">
                  {{site.reference}} - ({{site.street}} {{site.city}}/{{site.state}})
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
          <!-- Loading -->
          @if (installationSiteLoading) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Campo que contém a lista de tipos de luminárias -->
          <div class="form-step">
            <div class="circle-number"> 3 </div>
            <!-- Campo para realizar a busca de luminárias -->
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-lamps-type" | translate}} </mat-label>
              <input matInput #referenceLampType>
              <mat-icon class="component-search-icon" (click)="searchLampsType(referenceLampType.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>

          <!-- Loading -->
          @if (loadingLampType) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          @if (lampsTypeList.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready"> 3.1 </div>
            <!-- Campo que lista os concentradores filtrados -->
            <mat-form-field appearance="outline">
              <mat-label>
                {{"installations.register-form-select-lamp-type" | translate}}
              </mat-label>
              <mat-select formControlName="lampType" #value>
                @for (lampType of lampsTypeList; track lampType) {
                <mat-option apperance="outline" [value]="lampType.id">
                  {{lampType.manufacturer}} | {{lampType.power }}W ({{lampType.dimmingType}})
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Campo que contém a lista as divisiões (Subprefeituras) -->
          @if (divisionList.length > 0) {
          <div class="form-step">
            <div class="circle-number"> 3 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-division" | translate}} </mat-label>
              <mat-select formControlName="division">
                @for (divisions of divisionList; track divisions) {
                <mat-option [value]="divisions.id">
                  {{divisions.reference}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Campo que lista as aplicações -->
          <div class="form-step">
            <div class="circle-number"> 4 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-application" | translate}} </mat-label>
              <mat-select formControlName="applications">
                <mat-option value='PUBLIC_LIGHTING'> {{"installations.application-public-light" | translate}}
                </mat-option>
                <mat-option value='ELECTRICITY_CONSUMPTION'> {{"installations.application-electricity-consumption" |
                  translate}}</mat-option>
                <mat-option value='WATER_CONSUMPTION'> {{"installations.application-water-consumption" | translate}}
                </mat-option>
                <mat-option value='GAS_CONSUMPTION'> {{"installations.application-gas-consumption" | translate}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Campo para realizar a busca de concentradores -->
          @if (!virtualInstallationCheck) {
          <div class="form-step">
            <div class="circle-number"> 5 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-gateway" | translate}}</mat-label>
              <input matInput formControlName="gateway" #referenceGatewayCreate>
              <mat-icon class="component-search-icon" (click)="searchGateway(referenceGatewayCreate.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }
          <!-- Loading -->
          @if (loadingGateway) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Campo que contém a lista de concentradores filtrados -->
          @if (gatewayList.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready"> 5.1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-select-gateway" | translate}} </mat-label>
              <mat-select formControlName="gatewaySelected">
                @for (gateway of gatewayList; track gateway) {
                <mat-option [value]="gateway.id">
                  {{gateway.reference}}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Campo para realizar a busca dos equipamentos por numero de série -->
          @if (!virtualInstallationCheck) {
          <div class="form-step">
            <div class="circle-number"> 6 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{"installations.register-form-equipment-type" | translate}} </mat-label>
              <input matInput formControlName="equipmentsTypeCreate" #serialNumberEqpCreate>
              <mat-icon class="component-search-icon" (click)="searchEquipments(serialNumberEqpCreate.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }

          @if (equipmentsLoading) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Campo que contém a lista de equipamentos filtradas -->
          @if (equipmentList.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready"> 6.1 </div>
            <mat-form-field appearance="outline">
              <mat-label>
                {{"installations.register-form-select-equipment" | translate}}
              </mat-label>
              <mat-select formControlName="selectedEquipmentCreate">
                @for (equipments of equipmentList; track equipments) {
                <mat-option apperance="outline" [value]="equipments.id">
                  {{equipments.serialNumber}} ({{equipments.reference}}
                  {{equipments.major}}.{{equipments.minor}}.{{equipments.revision}} )
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Botão de criação -->
          @if (!createLoading) {
          <button class="btn btn-success" (click)="createInstallation()">
            {{"installations.button-save" | translate}}
          </button>
          }
          @if (createLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Tabela -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <!-- Header -->
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      }
      @if (length > 0) {
      <div class="table-container mt-2 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [paginator]="true" [rows]="pageSize" [totalRecords]="length"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference" style="width: 2rem;">{{"installations.column-table-reference" |
                translate}}
              </th>
              <th pSortableColumn="installationSite" style="width: 1rem">
                {{"installations.column-table-installation-location" | translate}}
              </th>
              <th pSortableColumn="equipmentType" style="width: 1rem">{{"installations.column-table-equipment-type" |
                translate}}</th>
              <th pSortableColumn="gateway" style="width: 1rem">{{"installations.column-table-gateway" | translate}}
              </th>
              <th pSortableColumn="lampsType" style="width: 1rem"> {{"installations.column-table-lamp-type" |
                translate}}
              </th>
              <th pSortableColumn="division" style="width: 1rem">{{"installations.column-table-division" | translate}}
              </th>
              <th pSortableColumn="magneticKey" style="width: 1rem">{{"installations.column-table-magnetic-key" |
                translate}}</th>
              <th pSortableColumn="status" style="width: 0.1rem">{{"installations.column-table-status" | translate}}
              </th>
              <th pSortableColumn="actions" style="width: 8rem">{{"installations.column-table-actions" | translate}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>
                {{row.reference}}
              </td>
              <td>{{row.site.district}}
                @if (row.site.district && row.site.city && row.site.street && row.site.number != null) {
                <span>
                  ,
                </span>
                }
                {{row.site.city}}
                @if (row.site.district && row.site.city && row.site.street && row.site.number != null) {
                <span>
                  ,
                </span>
                }
                {{row.site.street}}
                @if (row.site.district && row.site.city && row.site.street && row.site.number != null) {
                <span>
                  ,
                </span>
                }
                {{row.site.number}}
              </td>
              <td>{{row.device.reference}}
                {{row.device.major}}
                @if (row.device.reference && row.device.major && row.device.minor && row.device.revision != null) {
                <span>.</span>
                }
                {{row.device.minor}}
                @if (row.device.reference && row.device.major && row.device.minor && row.device.revision != null) {
                <span>.</span>
                }
                {{row.device.revision}}
              </td>
              <td> {{row.gateway.reference}}</td>
              <td>
                {{row.lampType.model}}
              </td>
              <td>{{row.division.reference}}</td>
              <td> @if (row.hasMagneticKey === true ) {
                <span>{{"installations.has-magnetic-key" |
                  translate}}</span>
                }
                @if (row.hasMagneticKey === false) {
                <span>{{"installations.no-magnetic-key" | translate}}</span>
                }
              </td>
              <td>
                @if (row.isActive === true ) {
                <span>{{"installations.status-active" | translate}}</span>
                }
                @if (row.isActive === false) {
                <span>{{"installations.status-inactive" | translate}}</span>
                }
              </td>
              <td>
                <!-- Botão de Edição -->
                <p-button (click)="openSidebarUpdate(row, false)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />

                <!-- Botão de Visualização -->
                <p-button (click)="openSidebarUpdate(row, true)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-eye" />

                <!-- Botão de Visualização dos logs -->
                <p-button (click)="openHistoryLogsSidebar(row)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-file" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
    }

    <!-- SideBar para edição/visualização -->
    @if (editorController) {
    <div class="sidebar-edit" [formGroup]="updateForm">
      <mat-icon class="component-close-icon" (click)="closeEditionSideBar()"> clear </mat-icon>
      @if (!viewController) {
      <h2 class="title-edit"> {{"installations.edit-form" | translate}} </h2>
      }
      @if (viewController) {
      <h2> {{"installations.view-form" | translate}} </h2>
      }
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-reference" | translate}} </mat-label>
        <input matInput formControlName="referenceUpdate">
      </mat-form-field>
      <section>
        <mat-checkbox formControlName="hasMagneticKey">
          {{"installations.edit-form-magnetic-key" | translate}}
        </mat-checkbox>
      </section>
      <br>
      <!-- Campo para realizar a busca de local de instalação -->
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-installation-location" | translate}} </mat-label>
        <input matInput formControlName="searchSiteUpdate" #referenceSiteUpdate required="">
        <mat-icon class="component-search-icon" (click)="searchInstallationSite(referenceSiteUpdate.value)"
          svgIcon="bx-search"></mat-icon>
      </mat-form-field>
      <!-- Loading -->
      @if (installationSiteLoading) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <!-- Campo que lista os locais de instalações filtrados -->
      @if (installationSiteList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>
          {{"installations.edit-form-select-installation-location" | translate}}
        </mat-label>
        <mat-select formControlName="siteSelectedUpdate" required="true">
          @for (site of installationSiteList; track site) {
          <mat-option apperance="outline" #value [value]="site.id">
            {{site.reference}} - ({{site.street}} {{site.city}}/{{site.state}})
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Campo para realizar a busca de equipamentos-->
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-equipment-type" | translate}}</mat-label>
        <input matInput formControlName="searchEquipmentUpdate" #referenceEquipUpdate>
        <mat-icon class="component-search-icon" (click)="searchEquipments(referenceEquipUpdate.value)"
          svgIcon="bx-search"></mat-icon>
      </mat-form-field>
      @if (equipmentsLoading) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <!-- Campo que lista os equipamentos filtrados -->
      @if (equipmentList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-select-equipment" | translate}} </mat-label>
        <mat-select formControlName="equipmentSelectedUpdate" #value>
          @for (equipments of equipmentList; track equipments) {
          <mat-option apperance="outline" [value]="equipments.id">
            {{equipments.serialNumber}} ({{equipments.reference}}
            {{equipments.major}}.{{equipments.minor}}.{{equipments.revision}} )
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Campo para realizar a busca de concentradores -->
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-gateway" | translate}} </mat-label>
        <input matInput formControlName="searchGatewayUpdate" #referenceGatewayUpdate>
        <mat-icon class="component-search-icon" (click)="searchGateway(referenceGatewayUpdate.value)"
          svgIcon="bx-search"></mat-icon>
      </mat-form-field>
      <!-- Loading -->
      @if (loadingGateway) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <!-- Campo que lista os concentradores filtrados -->
      @if (gatewayList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>
          {{"installations.edit-form-select-gateway" | translate}}
        </mat-label>
        <mat-select formControlName="gatewaySelectedUpdate" #value>
          @for (gateway of gatewayList; track gateway) {
          <mat-option apperance="outline" [value]="gateway.id">
            {{gateway.reference}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Campo para realizar a busca de luminárias -->
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-lamp-type" | translate}} </mat-label>
        <input matInput formControlName="searchLampTypeUpdate" #referenceLampType>
        <mat-icon class="component-search-icon" (click)="searchLampsType(referenceLampType.value)"
          svgIcon="bx-search"></mat-icon>
      </mat-form-field>
      <!-- Loading -->
      @if (loadingLampType) {
      <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
      }
      <!-- Campo que lista os tipos de luminária filtrados -->
      @if (lampsTypeList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>
          {{"installations.edit-form-select-lamp-type" | translate}}
        </mat-label>
        <mat-select formControlName="lampTypeSelectedUpdate" #value>
          @for (lampType of lampsTypeList; track lampType) {
          <mat-option apperance="outline" [value]="lampType.id">
            {{lampType.manufacturer}} | {{lampType.power }}W ({{lampType.dimmingType}})
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Campo que lista as divisões/subprefeituras (caso exista na empresa selecionada) -->
      @if (divisionList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-division" | translate}} </mat-label>
        <mat-select formControlName="division">
          @for (divisions of divisionList; track divisions) {
          <mat-option [value]="divisions.id" #value>
            {{divisions.reference}}
          </mat-option>
          }
          @if (createLoading) {
          <mat-option>
            <mat-spinner [diameter]="30"></mat-spinner>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Lista as aplicações -->
      <mat-form-field appearance="outline">
        <mat-label> {{"installations.edit-form-application" | translate}} </mat-label>
        <mat-select formControlName="applications">
          <mat-option value='PUBLIC_LIGHTING'> {{"installations.edit-public-light" | translate }} </mat-option>
          <mat-option value='ELECTRICITY_CONSUMPTION'> {{"installations.edit-electricity-consumption" | translate}}
          </mat-option>
          <mat-option value='WATER_CONSUMPTION'> {{"installations.edit-water-consumption" | translate}} </mat-option>
          <mat-option value='GAS_CONSUMPTION'> {{"installations.edit-gas-consumption" | translate}} </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- Botões de edição. -->
      @if (!viewController) {
      <div class="d-flex m-2" id="buttons-edit">
        @if (!viewController && updateForm.value.isActive ) {
        <button class="btn btn-success m-1 w-50" (click)="updateInstallation()">
          {{"installations.button-save" | translate}}
        </button>
        }
        @if (updateForm.value.isActive) {
        <button class="btn btn-secondary m-1 w-50" (click)="updateStatusInstallation(false)">
          {{"installations.button-inactivate" | translate}}
        </button>
        }
        @if (!updateForm.value.isActive) {
        <button class="btn btn-secondary m-1 w-50" (click)="updateStatusInstallation(true)">
          {{"installations.button-activate" | translate}}
        </button>
        }

      </div>
      }
    </div>
    }

    <ng-template #dialogTemplate let-dialogRef="dialogRef">
      <mat-dialog-content class="mat-typography">
        <div class="dialogRef" style="text-align: center;">
          @if (loadingLogs) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
          @if (loadingLogs) {
          <span style="font-size:20px; color: #2633d8">{{'installations.loading-logs-message' |
            translate}} </span>
          }

          @if (!loadingLogs) {
          <h1 mat-dialog-title>{{'installations.title-device-history-logs' | translate}}</h1>
          }
          @if (!loadingLogs) {
          <hr>
          }

          @for (item of devicesLogsList; track item) {
          <div class="d-flex align-items-start flex-column text-center" style="font-size: 19px;">
            <div class="p-2">
              @if (!loadingLogs) {
              <strong> {{'installations.start-date-time' | translate}}
              </strong>
              }{{item.startDatetime}}
            </div>
            <div class="p-2">
              @if (!loadingLogs) {
              <strong>{{'installations.serial-number' | translate}}</strong>
              }
              {{item.device.serialNumber}}
            </div>
            <div class="p-2">
              @if (!loadingLogs) {
              <strong> {{'installations.mac-address' | translate}} </strong>
              }
              {{item.device.macAddress}}
            </div>
            @if (devicesLogsList.length > 1) {
            <mat-divider></mat-divider>
            }
          </div>
          }
          @if (logsNotFound) {
          <strong style="font-size:18px;">{{'installations.no-logs-message' |translate}}</strong>
          }
        </div>
      </mat-dialog-content>
    </ng-template>
  </div>